import { observer } from 'mobx-react-lite'
import { PresentationModeContent } from 'widgets/PresentationMode/ui/PresentationModeContent'
import { usePresentationModeContext } from 'widgets/PresentationMode'

export const PresentationMode = observer(() => {
  const presentationStore = usePresentationModeContext()
  const { currentAttachment, openPresentationMode } = presentationStore

  if (!openPresentationMode || !currentAttachment) {
    return null
  }

  return <PresentationModeContent />
})
